<template>
  <div>
    <div class="dashboard">
      <div class="dashboard-header mb-6">
        <div class="header-content">
          <div class="left-section">
            <div class="update-info">
              <span>Última atualização: {{ data }}</span>
              <v-icon class="ml-2" color="primary" @click="loadDashboard"
                >mdi-cached</v-icon
              >
            </div>
          </div>

          <div class="center-section">
            <h1 class="titulo-principal">Inscrições Ciclo 2026</h1>
          </div>

          <div class="right-section">
            <div class="compact-timer">
              <div class="timer-badge">
                <img
                  :src="require('@/assets/icons/alarm.png')"
                  style="width: 24px"
                />
                <span class="dias-count">{{ faltamDias }}</span>
                <span class="dias-label">dias</span>
              </div>
              <div class="deadline-info">
                <small>Prazo: 30/04/2026</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Filtros Centralizados -->
      <div class="filters-section mb-6">
        <v-card class="filters-card pa-4" elevation="2">
          <v-row class="filters-row" align="center" justify="center">
            <v-col cols="12" sm="4" md="3">
              <combo-estados
                :filter="payload"
                :tipoInscricao="'A'"
                multiple
              ></combo-estados>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-autocomplete
                id="temas-select"
                v-model="payload.ano"
                :items="anos"
                placeholder="Selecione um ano"
                label="Ano"
                filled
                :clearable="true"
                :return-object="true"
                hide-details="auto"
                multiple
              >
                <template slot="no-data"> Nenhum Ator retornado </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-btn color="primary" @click="loadDashboard" block
                >Filtrar</v-btn
              >
            </v-col>
          </v-row>
        </v-card>
      </div>

      <!-- Seção Principal: Gráficos + Cards -->
      <div class="main-content-section">
        <v-row class="main-row" no-gutters>
          <!-- Coluna dos Cards -->
          <div cols="3" class="cards-column">
            <div class="totals-section">
              <div class="totals-grid">
                <v-card
                  class="total-card card-2026"
                  elevation="4"
                  v-if="
                    !anoEscolhido ||
                    anoEscolhido.length == 0 ||
                    anoEscolhido.includes('2026')
                  "
                >
                  <div class="card-header">Ciclo 2026</div>
                  <div class="card-total">{{ payload.totalInsc2026 }}</div>
                  <div class="card-subtitle">Sala + Parceiro</div>
                </v-card>
                <v-card
                  class="total-card card-2025"
                  elevation="4"
                  v-if="
                    !anoEscolhido ||
                    anoEscolhido.length == 0 ||
                    anoEscolhido.includes('2025')
                  "
                >
                  <div class="card-header">Ciclo 2025</div>
                  <div class="card-total">{{ payload.totalInsc2025 }}</div>
                  <div class="card-subtitle">Sala + Parceiro</div>
                </v-card>

                <v-card
                  class="total-card card-2024"
                  elevation="4"
                  v-if="
                    !anoEscolhido ||
                    anoEscolhido.length == 0 ||
                    anoEscolhido.includes('2024')
                  "
                >
                  <div class="card-header">Ciclo 2024</div>
                  <div class="card-total">{{ payload.totalInsc2024 }}</div>
                  <div class="card-subtitle">Sala + Parceiro</div>
                </v-card>
                <v-card
                  class="total-card card-2023"
                  elevation="4"
                  v-if="
                    !anoEscolhido ||
                    anoEscolhido.length == 0 ||
                    anoEscolhido.includes('2023')
                  "
                >
                  <div class="card-header">Ciclo 2023</div>
                  <div class="card-total">{{ payload.totalInsc2023 }}</div>
                  <div class="card-subtitle">Sala + Parceiro</div>
                </v-card>

                <v-card
                  class="total-card card-comparison"
                  elevation="4"
                  v-if="
                    !anoEscolhido ||
                    anoEscolhido.length == 0 ||
                    !onlyOneYear('2025')
                  "
                >
                  <div class="card-header">Comparativo</div>
                  <div class="card-comparison-text">
                    <template
                      v-if="
                        anoEscolhido.includes('2023') ||
                        (anoEscolhido.includes('2024') &&
                          anoEscolhido.length < 4)
                      "
                    >
                      <template
                        v-if="
                          (onlyOneYear('2023') ||
                            anoEscolhido.includes('2024')) &&
                          !anoEscolhido.includes('2025') &&
                          !anoEscolhido.includes('2026')
                        "
                      >
                        <span class="percentage"
                          >{{
                            parseInt(
                              (payload.totalInsc2024 / payload.totalInsc2023) *
                                100
                            ) || 0
                          }}%</span
                        >
                        <span class="comparison-label">2023 → 2024</span>
                      </template>
                      <template
                        v-else-if="
                          !anoEscolhido.includes('2024') &&
                          anoEscolhido.includes('2025') &&
                          !anoEscolhido.includes('2026')
                        "
                      >
                        <span class="percentage"
                          >{{
                            parseInt(
                              (payload.totalInsc2025 / payload.totalInsc2023) *
                                100
                            ) || 0
                          }}%</span
                        >
                        <span class="comparison-label">2023 → 2025</span>
                      </template>

                      <template
                        v-else-if="
                          !anoEscolhido.includes('2024') &&
                          !anoEscolhido.includes('2025') &&
                          anoEscolhido.includes('2026')
                        "
                      >
                        <span class="percentage"
                          >{{
                            parseInt(
                              (payload.totalInsc2026 / payload.totalInsc2023) *
                                100
                            ) || 0
                          }}%</span
                        >
                        <span class="comparison-label">2023 → 2026</span>
                      </template>

                      <template
                        v-else-if="
                          !anoEscolhido.includes('2023') &&
                          !anoEscolhido.includes('2026') &&
                          anoEscolhido.includes('2024')
                        "
                      >
                        <span class="percentage"
                          >{{
                            parseInt(
                              (payload.totalInsc2025 / payload.totalInsc2024) *
                                100
                            ) || 0
                          }}%</span
                        >
                        <span class="comparison-label">2024 → 2025</span>
                      </template>
                      <template
                        v-else-if="
                          !anoEscolhido.includes('2023') &&
                          !anoEscolhido.includes('2025') &&
                          anoEscolhido.includes('2024')
                        "
                      >
                        <span class="percentage"
                          >{{
                            parseInt(
                              (payload.totalInsc2026 / payload.totalInsc2024) *
                                100
                            ) || 0
                          }}%</span
                        >
                        <span class="comparison-label">2024 → 2026</span>
                      </template>
                    </template>
                    <template v-else>
                      <span class="percentage"
                        >{{
                          parseInt(
                            (payload.totalInsc2026 / payload.totalInsc2025) *
                              100
                          ) || 0
                        }}%</span
                      >
                      <span class="comparison-label">2025 → 2026</span>
                    </template>
                  </div>
                </v-card>
              </div>
            </div>
          </div>
          <!-- Coluna dos Gráficos -->
          <div cols="9" class="charts-column">
            <div class="charts-section">
              <!-- Instrução para interação com gráficos -->
              <div class="chart-instruction mb-3">
                <v-alert
                  type="info"
                  outlined
                  dense
                  class="mb-3"
                  style="border-left: 4px solid #1976d2"
                >
                  <div class="d-flex align-center">
                    <v-icon color="primary" class="mr-2"
                      >mdi-cursor-default-outline</v-icon
                    >
                    <span class="font-weight-medium"
                      >Passe o mouse sobre as barras para ver os valores
                      detalhados</span
                    >
                  </div>
                </v-alert>
              </div>
              <!-- Gráfico Salas -->
              <v-card class="chart-card mb-4" elevation="3">
                <v-card-title class="chart-title justify-center">
                  <h3 class="chart-heading">Inscrições de sala por estado</h3>
                </v-card-title>
                <v-card-text>
                  <div class="chart-container">
                    <bar-chart
                      :chart-data="lineChart"
                      :options="lineChartOptions"
                      :width="200"
                      :height="300"
                      class="chart"
                    ></bar-chart>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Gráfico Parceiros -->
              <v-card class="chart-card mb-4" elevation="3">
                <v-card-title class="chart-title justify-center">
                  <h3 class="chart-heading">
                    Inscrições de parceiro por estado
                  </h3>
                </v-card-title>
                <v-card-text>
                  <div class="chart-container">
                    <bar-chart
                      :chart-data="lineChartParceiro"
                      :options="lineChartOptions"
                      :width="200"
                      :height="300"
                      class="chart"
                    ></bar-chart>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </v-row>

        <!-- Notas explicativas -->
        <div class="legend-note mt-3">
          <div class="mb-2">
            <small class="text--secondary">
              <v-icon small color="grey">mdi-information-outline</v-icon>
              Os valores dos cards representam a soma total de inscrições de
              salas e parceiros
            </small>
          </div>
          <small class="text--secondary">
            <v-icon small color="grey">mdi-information-outline</v-icon>
            ⚠️ Indica anos sem dados disponíveis
          </small>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ComboMunicipio from "@/modules/municipios/components/ComboMunicipio";
import ComboEstados from "@/modules/municipios/components/ComboEstados";
import SeloLogo from "@/components/seloLogo";
import { dashboardAPI } from "@/apis";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import ComboTipoInscricao from "@/modules/inscricao/components/comboTipoInscricao";
import BarChart from "@/components/chart/BarChart";
import { criarLinkRelatorio } from "@/helpers/gerarRelatorio";

export default {
  components: {
    ComboMunicipio,
    ComboEstados,
    SeloLogo,
    ComboTipoInscricao,
    BarChart,
  },
  computed: {
    ...mapGetters(["isFullAdmin"]),
    faltamDias() {
      return moment("30/04/2026", "DD/MM/YYYY")
        .startOf("day")
        .diff(moment().startOf("day"), "days");
    },
    user() {
      return JSON.parse(localStorage.getItem("user") || "{}");
    },
    shouldShowDataLabels() {
      // Verifica se payload.uf tem menos itens que o máximo
      const payloadUfValid =
        this.payload.uf &&
        this.payload.uf.length > 0 &&
        this.payload.uf.length < this.maximoGraficosLegenda;

      // Verifica se user.ufs existe, parseia e verifica se tem menos itens que o máximo
      const userUfsValid =
        this.user.ufs &&
        this.user.ufs.split(",").filter((uf) => uf.trim()).length <
          this.maximoGraficosLegenda;

      return payloadUfValid || (userUfsValid && !this.isFullAdmin);
    },
  },
  data() {
    return {
      maximoGraficosLegenda: 10,
      payload: {
        totalInsc2023: 0,
        totalInsc2024: 0,
        totalInsc2025: 0,
        totalInsc2026: 0,

        variacao: 0,
        valoresTabela: [],
        tipo: [],
        ano: [],
        uf: [],
      },
      data: this.now(),
      anos: ["2026", "2025", "2024", "2023"],
      headers: [
        { text: "Uf", value: "uf", width: "10%" },
        { text: "Municipio", value: "municipio" },
        {
          text: "Inscrito",
          value: "nomeSala",
          width: "50%",
        },
        ,
      ],
      inscricoes: [],
      lineChart: {},
      lineChartParceiro: {},
      lineChartOptions: {
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            pointStyle: "circle",
            padding: 15,
            fontSize: 11,
            boxWidth: 10,
          },
        },
        layout: {
          padding: {
            top: 20,
            bottom: 40,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          customScale: {
            grace: "20%",
            // grace: 40
          },
          datalabels: {
            anchor: "end",
            align: "top",
            offset: 4,
            color: "#333",
            font: {
              weight: "bold",
              size: 12,
            },
            formatter: (value, context) => {
              return value > 0 ? value : "";
            },
          },
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                display: true,
              },
              ticks: {
                suggestedMin: 0,
              },
            },
          ],
          xAxes: [
            {
              categoryPercentage: 0.6,
              barPercentage: 0.8,
              ticks: {
                callback: function (label) {
                  if (label == null) {
                    return "";
                  }
                  if (label.length > 15) {
                    label = label.substring(0, 15);
                    label += "...";
                  }
                  return label;
                },
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },

        responsive: true,
        maintainAspectRatio: false,
      },
      anoEscolhido: [],
      timer: null,
      user: JSON.parse(localStorage.getItem("user") || "{}"),
    };
  },
  mounted() {
    this.fillLineChart();
    this.loadDashboard();
  },

  created() {
    this.timer = setInterval(() => {
      this.loadDashboard();
    }, 1800000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    ...mapActions(["setLoading"]),
    onlyOneYear(ano) {
      if (
        this.anoEscolhido &&
        this.anoEscolhido.length == 1 &&
        this.anoEscolhido.includes(ano)
      )
        return true;

      return false;
    },
    nomeDashboard() {
      if (!this.anoEscolhido || this.anoEscolhido.length == 0)
        return "2023 a 2025";

      if (
        this.anoEscolhido.includes("2023") &&
        this.anoEscolhido.includes("2024") &&
        this.anoEscolhido.includes("2025")
      )
        return "2023 a 2025";

      if (
        this.anoEscolhido.includes("2023") &&
        this.anoEscolhido.includes("2025")
      )
        return "2023 x 2025";

      if (
        this.anoEscolhido.includes("2023") &&
        this.anoEscolhido.includes("2024")
      )
        return "2023 x 2024";

      if (
        this.anoEscolhido.includes("2024") &&
        this.anoEscolhido.includes("2025")
      )
        return "2024 x 2025";

      if (this.anoEscolhido.includes("2025")) return "2025";
      if (this.anoEscolhido.includes("2023")) return "2023";
      if (this.anoEscolhido.includes("2024")) return "2024";
    },
    getTotais(comparativo) {
      return dashboardAPI.obterTotais(comparativo);
    },
    getInscricoes2023(comparativo) {
      return dashboardAPI.totalInscricao2023(comparativo);
    },
    getInscricoes2024(comparativo) {
      return dashboardAPI.totalInscricao2024(comparativo);
    },
    getInscricoes2025(comparativo) {
      return dashboardAPI.totalInscricao2025(comparativo);
    },
    comparativoInscricao(comparativo) {
      return dashboardAPI.comparacaoAno(comparativo);
    },
    comparativoInscricaoParceiro(comparativo) {
      return dashboardAPI.comparacaoAnoParceiro(comparativo);
    },
    getTabela(comparativo) {
      return dashboardAPI.getTabela(comparativo);
    },
    promiseAllSettledPollyfill() {
      if (!Promise.allSettled) {
        const rejectHandler = (reason) => ({ status: "rejected", reason });

        const resolveHandler = (value) => ({ status: "fulfilled", value });

        Promise.allSettled = function (promises) {
          const convertedPromises = promises.map((p) =>
            Promise.resolve(p).then(resolveHandler, rejectHandler)
          );
          return Promise.all(convertedPromises);
        };
      }
    },
    now() {
      this.data = moment().format("DD/MM/YYYY HH:mm:ss");
    },
    gerarXls() {
      this.setLoading(true);
      let comparativo = {
        uf:
          (this.payload.uf &&
            this.payload.uf.map((item) => `'${item}'`).join(",")) ||
          "",
        tipo: (this.payload.tipo && this.payload.tipo.join(",")) || "",
      };
      dashboardAPI
        .gerarXls(comparativo)
        .then(({ data }) => {
          criarLinkRelatorio(
            data,
            `Inscrições 2025 - ${moment().format("DD_MM_YYYY_HH_mm")}.xlsx`
          );
          this.setLoading(false);
        })
        .catch((err) => {
          console.log("Erro em gerarXls no dashboard.vue: ", err);
          this.$notification.error("Ocorreu um erro ao gerar o relatório.", {
            timer: 5,
          });
          this.setLoading(false);
        });
    },

    loadDashboard() {
      let comparativo = {
        uf:
          (this.payload.uf &&
            this.payload.uf.map((item) => `'${item}'`).join(",")) ||
          "",
        tipo: (this.payload.tipo && this.payload.tipo.join(",")) || "",
      };
      this.setLoading(true);
      this.promiseAllSettledPollyfill();

      Promise.allSettled([
        this.getTotais(comparativo),
        this.comparativoInscricao(comparativo),
        this.comparativoInscricaoParceiro(comparativo),
      ]).then((results) => {
        this.setLoading(false);
        results.forEach((result, idx) => {
          if (result.status == "fulfilled") {
            if (idx == 0) {
              const data =
                result.value.data.data[0] && result.value.data.data[0];

              this.payload.totalInsc2023 = data.total2023 || 0;
              this.payload.totalInsc2024 = data.total2024 || 0;
              this.payload.totalInsc2025 = data.total2025 || 0;
              this.payload.totalInsc2026 = data.total2026 || 0;
            }

            if (idx == 1)
              this.fillLineChart(
                result.value.data.data,
                this.payload.ano,
                "lineChart"
              );

            if (idx == 2)
              this.fillLineChart(
                result.value.data.data,
                this.payload.ano,
                "lineChartParceiro"
              );

            this.now();
          }
          if (result.status == "rejected") {
            this.$notification.error(
              "Ocorreu um erro, entre em contato com o administrador do sistema.",
              { timer: 5 }
            );
          }
        });
      });
    },
    calculateMax(max) {
      return max || 600;
    },
    fillLineChart(val, ano, lineName) {
      if (ano) this.anoEscolhido = ano;

      let valores = val || [];

      // Verifica se há dados para cada ano
      const hasData2023 = valores.some((item) => item.inscritos2023 > 0);
      const hasData2024 = valores.some((item) => item.inscritos2024 > 0);
      const hasData2025 = valores.some((item) => item.inscritos2025 > 0);
      const hasData2026 = valores.some((item) => item.inscritos2026 > 0);
      console.log("this.payload.uf: ", this.payload.uf);
      const dash = {
        labels: valores.map((item) => item.uf),
        datasets: [
          {
            label: hasData2023 ? "2023" : "⚠️ 2023",
            data: valores.map((item) => item.inscritos2023),
            backgroundColor: "#65b4f8",
            borderWidth: 2,
            borderRadius: 10,
            borderSkipped: false,
            ano: 2023,
            datalabels: {
              display: this.shouldShowDataLabels,
            },
          },
          {
            label: hasData2024 ? "2024" : "⚠️ 2024",
            data: valores.map((item) => item.inscritos2024),
            backgroundColor: "#16a34a",
            borderWidth: 2,
            borderRadius: 10,
            borderSkipped: false,
            ano: 2024,
            datalabels: {
              display: this.shouldShowDataLabels,
            },
          },
          {
            label: hasData2025 ? "2025" : "⚠️ 2025",
            data: valores.map((item) => item.inscritos2025),
            backgroundColor: "#f59e0b",
            borderWidth: 2,
            borderRadius: 10,
            borderSkipped: false,
            ano: 2025,
            datalabels: {
              display: this.shouldShowDataLabels,
            },
          },
          {
            label: hasData2026 ? "2026" : "⚠️ 2026",
            data: valores.map((item) => item.inscritos2026),
            backgroundColor: "#991b1b",
            borderWidth: 2,
            borderRadius: 10,
            borderSkipped: false,
            ano: 2026,
            datalabels: {
              display: this.shouldShowDataLabels,
            },
          },
        ].filter((item) => {
          if (!ano || ano.length == 0) return item;
          else return ano.some((val) => val == item.ano);
        }),
      };

      console.log("dash: ", dash);
      this[lineName] = dash;
    },
  },
};
</script>
<style>
.v-data-footer {
  justify-content: center;
}
</style>
<style scoped lang="scss">
.dashboard {
  padding: 0 16px;

  .dashboard-header {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 24px;

    .header-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;

      .left-section {
        flex: 1;
        display: flex;
        justify-content: flex-start;

        .update-info {
          display: flex;
          align-items: center;
          color: #666;
          font-size: 13px;
          background: rgba(255, 255, 255, 0.8);
          padding: 8px 12px;
          border-radius: 20px;
          backdrop-filter: blur(10px);
        }
      }

      .center-section {
        flex: 2;
        text-align: center;

        .titulo-principal {
          color: #2d6189;
          font-size: 2.2rem;
          font-weight: 400;
          margin: 0;
        }
      }

      .right-section {
        flex: 1;
        display: flex;
        justify-content: flex-end;

        .compact-timer {
          background: rgba(255, 255, 255, 0.9);
          padding: 12px 16px;
          border-radius: 16px;
          text-align: center;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
          backdrop-filter: blur(10px);

          .timer-badge {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            margin-bottom: 4px;

            .dias-count {
              font-weight: bold;
              font-size: 20px;
              color: #d32f2f;
            }

            .dias-label {
              font-size: 12px;
              color: #2d6189;
              font-weight: 600;
            }
          }

          .deadline-info {
            small {
              color: #666;
              font-size: 11px;
            }
          }
        }
      }
    }
  }

  .filters-section {
    .filters-card {
      border-radius: 12px;

      .filters-row {
        gap: 16px;
      }
    }
  }

  .main-content-section {
    .main-row {
      gap: 16px;
      flex-wrap: nowrap;
    }

    .charts-column {
      padding-right: 8px;
      width: 100%;
    }

    .cards-column {
      padding-left: 8px;
    }
  }

  .charts-section {
    .chart-card {
      border-radius: 12px;
      transition: transform 0.2s, box-shadow 0.2s;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
      }

      .chart-title {
        background: linear-gradient(135deg, #2d6189 0%, #1976d2 100%);
        color: white;
        padding: 16px;
        margin: 0;

        .chart-heading {
          color: white;
          font-size: 1.2rem;
          font-weight: 500;
          text-align: center;
          margin: 0;
        }
      }

      .chart-container {
        padding: 24px;
      }
    }
  }

  .totals-section {
    height: 100%;

    .totals-grid {
      display: flex;
      flex-direction: column;
      gap: 12px;
      padding: 8px;
    }

    .totals-container {
      border-radius: 12px;
      height: 100%;

      .totals-header {
        background: linear-gradient(135deg, #2d6189 0%, #1976d2 100%);
        color: white;
        padding: 12px;

        h4 {
          color: white;
          font-size: 1.1rem;
          font-weight: 500;
          margin: 0;
        }
      }
    }

    .total-card {
      border-radius: 8px;
      padding: 16px;
      text-align: center;
      color: white;
      min-height: 100px;
      display: flex;
      width: 250px;
      flex-direction: column;
      justify-content: center;
      transition: transform 0.2s, box-shadow 0.2s;

      &:hover {
        transform: translateX(4px);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
      }

      .card-header {
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 8px;
        opacity: 0.9;
      }

      .card-total {
        font-size: 2rem;
        font-weight: 700;
        line-height: 1;
      }

      .card-subtitle {
        font-size: 10px;
        font-weight: 500;
        margin-top: 4px;
        opacity: 0.8;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      &.card-2023 {
        background: linear-gradient(135deg, #65b4f8 0%, #4a90e2 100%);
      }

      &.card-2024 {
        background: linear-gradient(135deg, #16a34a 0%, #15803d 100%); // Verde
      }

      &.card-2025 {
        background: linear-gradient(
          135deg,
          #f59e0b 0%,
          #d97706 100%
        ); // Amarelo ouro
      }

      &.card-2026 {
        background: linear-gradient(135deg, #991b1b 0%, #7f1d1d 100%); // Vinho
      }

      &.card-comparison {
        background: linear-gradient(135deg, #2d6189 0%, #1976d2 100%);

        .card-comparison-text {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;

          .percentage {
            font-size: 1.8rem;
            font-weight: 700;
            line-height: 1;
          }

          .comparison-label {
            font-size: 11px;
            opacity: 0.9;
            font-weight: 500;
          }
        }
      }
    }
  }
}

.chart {
  width: 100%;
  height: 100%;
}

.legend-note {
  text-align: center;
  padding: 12px 0;

  .v-icon {
    margin-right: 4px;
  }

  .text--secondary {
    display: inline-flex;
    align-items: center;
    color: #666 !important;
    font-style: italic;
  }
}

.xls {
  display: flex;
  column-gap: 10px;
  font-weight: 700;
  align-items: center;
  cursor: pointer;
  margin-bottom: 1rem;
}

@media screen and (max-width: 768px) {
  .dashboard {
    padding: 0 8px;

    .dashboard-header {
      padding: 16px;

      .header-content {
        flex-direction: column;
        gap: 16px;

        .left-section,
        .right-section {
          flex: none;
        }

        .center-section {
          .titulo-principal {
            font-size: 1.8rem;
          }
        }

        .right-section .compact-timer {
          .timer-badge {
            .dias-count {
              font-size: 18px;
            }
          }
        }
      }
    }

    .filters-section .filters-card {
      padding: 16px;
    }

    .main-content-section {
      .charts-column,
      .cards-column {
        padding: 0;
      }
    }

    .totals-section {
      margin-bottom: 16px;

      .totals-container .totals-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
      }

      .total-card {
        min-height: 80px;
        padding: 12px;

        .card-total {
          font-size: 1.5rem;
        }

        .card-subtitle {
          font-size: 9px;
          margin-top: 2px;
        }

        &.card-comparison .card-comparison-text .percentage {
          font-size: 1.3rem;
        }
      }
    }

    .charts-section {
      .chart-card {
        margin-bottom: 16px;

        .chart-title .chart-heading {
          font-size: 1.1rem;
        }

        .chart-container {
          padding: 8px;
          min-height: 250px;
        }
      }
    }
  }
}

@media screen and (min-width: 769px) {
  .dashboard {
    .filters-section {
      .filters-row {
        justify-content: center;
      }
    }
  }
}
</style>
